<template>
  <div style="background-color: #ffffff">
    <nu-modal ref="termsModal" title="">
      <div class="container-fluid">
        <div class="row">
          <!-- Ticket Cart -->
          <div
            class="row align-items-center justify-content-between"
            style="margin: auto; width: 100% !important"
          >
            <div class="col-md-12">
              <div class="text-center">
                <span
                  class="w-auto d-inline-block"
                  style="
                    font-family: 'nunito';
                    font-size: 2.3em;
                    font-weight: 700;
                    color: #000000;
                  "
                >
                  THE GAME OF POLO
                </span>
              </div>
            </div>
            <div class="col-lg-12 col-md-12">
              <div style="height: auto; overflow: auto">
                <p
                  class="mb-1 mt-3"
                  style="
                    font-family: 'Wix Madefor Text', sans-serif;
                    font-size: 1.1em;
                    color: black;
                    width: 100%;
                  "
                >
                  <span class="bolded">
                    The sport of Kings bringing back ALL Black Polo Players!
                  </span>

                  <br /><br />

                  <span class="bolded"> Origins of Polo </span>
                  <br />
                  Polo is the oldest ball sport in the world dating back to 600
                  BC. Polo is derived from the “pulu”, the willow root from
                  which the polo balls were crafted in Tibet over 2000 years
                  ago.
                  <br />
                  The sport gradually spread through Asia to India, where it was
                  introduced to tea planters and British soldiers, who brought
                  the game to England. The first match was played in the UK in
                  1871 between the 9th lancers and 10th Hussars. One of the
                  players in this match was Captain Frank Henry who started the
                  Beaufort Polo Club in 1872.
                  <br />
                  <br />
                  <span class="bolded"> Polo for the Spectator </span>
                  <br />
                  What makes polo such a special spectator sport is that you
                  don’t have to be familiar with the rules, allowing you to take
                  in the thrill and excitement of one of the fastest team sports
                  in the world. The following information is designed to give
                  you an insight into the finer parts of the game of polo.
                  <br /><br />
                  <span class="bolded"> The Game </span>
                  <br />
                  The aim of the game is to score more goals than your opposing
                  team! Play starts initially, and after each goal, with an
                  umpire throwing the ball among the players in the middle of
                  the ground. Ends are changed after each goal – this has been
                  found to be the fairest way for teams not to be disadvantaged
                  by wind or slopes on the pitch! When the ball goes out of play
                  over the sides of the ground, teams line up side by side five
                  yards back and the ball is thrown in.
                  <br />
                  If the ball crosses the back line, being last touched by the
                  attacking team, the defending team takes a free hit from where
                  the ball crossed the line. Should the defending team hit the
                  ball over the back line a penalty is called and the attacking
                  team is given a free hit from the 60 yard line opposite where
                  the ball went out. There is no ‘corner’ or offside as in
                  football.
                  <br /><br />
                  <span class="bolded">The Ground </span>
                  <br />
                  The ground is 300 yards long (274m) long and 200m (182m) wide,
                  or if there are boards down the side (to help keep the ball in
                  play) then 160 yards 182 wide. The goal posts (collapsible on
                  severe impact for safety) are eight yards (7.3m) apart. There
                  is a line at the centre of the ground and penalty lines, 30,
                  40 and 60 yards from each back line. A polo ground is roughly
                  the size of 6 football pitches!
                  <br /><br />
                  <span class="bolded">Duration of Play</span>
                  <br />
                  The game is played over four, five or six periods of 7 minutes
                  each which are called by the Indian name “Chukka”. At the end
                  of the Chukka the first bell is rung, but play continues until
                  the ball goes out of play or the second bell is rung.
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </nu-modal>

    <!-- form starts -->
    <vue-element-loading
      :active="isSubmitted"
      text="MYLE"
      :text-style="loadStyle"
      :is-full-screen="true"
      class="h-full background-overlay"
      spinner="bar-fade-scale"
      color="#ffffff"
    />

    <stripe-checkout
      ref="checkoutRef"
      mode="payment"
      :pk="checkout.publishKey"
      :sessionId="checkout.clientReferenceId"
    />

    <!-- conifrm model -->
    <nu-modal ref="confirmmodal" title="">
      <confirmationPopup :showsuccess="showsuccess" @closemodal="closeModal" />
    </nu-modal>
    <!-- confrim model -->

    <nu-modal ref="modal" title="">
      <form>
        <div class="container-fluid">
          <div class="row">
            <!-- Ticket Cart -->
            <div class="col-md-12">
              <div class="text-center">
                <h4
                  class="w-auto d-inline-block"
                  style="
                    font-family: 'Wix Madefor Text', sans-serif;
                    font-weight: 700;
                    font-size: 2.2em;
                    color: #000000;
                  "
                >
                  Purchase
                </h4>
              </div>
            </div>

            <div class="col-md-6 mt-3">
              <span
                class="w-auto d-inline-block labels"
                style="
                  font-family: 'Wix Madefor Text', sans-serif;
                  font-weight: 400;
                  font-size: 1.2em;
                  color: black;
                "
              >
                Full Name
              </span>
              <input
                type="text"
                class="form-control mb-3"
                placeholder="Full Name"
                required
                v-model="fullname"
              />
            </div>
            <div class="col-md-6 mt-3">
              <span
                class="w-auto d-inline-block labels"
                style="
                  font-family: 'Wix Madefor Text', sans-serif;
                  font-weight: 400;
                  font-size: 1.2em;
                  color: black;
                "
              >
                Email
              </span>
              <input
                type="email"
                class="form-control mb-3"
                placeholder="Email"
                v-model="email"
                required
              />
            </div>

            <div class="col-md-6 mt-3">
              <label
                class=""
                style="
                  font-family: 'Wix Madefor Text', sans-serif;
                  font-weight: 400;
                  font-size: 1.2em;
                  color: black;
                "
                >Phone
              </label>
              <input
                type="text"
                class="form-control"
                placeholder="Enter phone number"
                @keypress="isNumber()"
                v-model="userContactPhone"
              />
              <span
                v-bind:class="{ 'op-0': invaliduphone }"
                class="mb-3"
                style="color: red; font-size: 12px"
                >*please fill valid phone number</span
              >
            </div>

            <div class="col-md-6 mt-3">
              <label
                class=""
                style="
                  font-family: 'Wix Madefor Text', sans-serif;
                  font-weight: 400;
                  font-size: 1.2em;
                  color: black;
                "
              >
                Business Name (optional)
              </label>
              <input
                type="text"
                v-model="nameOfBusiness"
                class="form-control"
                placeholder="Name of your business"
              />
            </div>

            <div class="col-md-6 mt-3">
              <label
                class=""
                style="
                  font-family: 'Wix Madefor Text', sans-serif;
                  font-weight: 400;
                  font-size: 1.2em;
                  color: black;
                "
              >
                Interested in Pitching?
              </label>
              <select
                class="form-control"
                style="
                  font-family: 'nunito', sans-serif;
                  font-weight: 300;
                  font-size: 1.1rem;
                  color: black;
                "
                v-model="interested"
              >
                <option
                  class="form-control"
                  v-bind:key="count + 'byes'"
                  v-for="count in ['Yes', 'No']"
                  :value="count"
                >
                  {{ count }}
                </option>
              </select>
            </div>

            <hr v-if="!isDonate" class="w-100 p-2" />
            <!-- Ticket Cart -->

            <!-- Ticket Options -->
            <div class="col-md-12" v-if="!isDonate && !isSponsor">
              <div class="text-center">
                <h4
                  class="w-auto d-inline-block"
                  style="
                    font-family: 'Wix Madefor Text', sans-serif;
                    font-weight: 700;
                    font-size: 2.2em;
                    color: #000000;
                  "
                >
                  Ticket Options
                </h4>
              </div>
            </div>

            <div class="col-md-4" v-if="!isDonate && !isSponsor">
              <label
                class="mt-3"
                style="
                  font-family: 'Wix Madefor Text', sans-serif;
                  font-weight: 400;
                  font-size: 1.2em;
                  color: black;
                "
                >Ticket Type</label
              >
              <select
                @change="
                  (e) => {
                    redeemData = null;
                    redeempromo = '';
                    dayChange('daylist', e.target.value);
                  }
                "
                class="form-control"
                v-model="daylistx"
              >
                <option
                  class="form-control"
                  v-bind:key="count + 'axb'"
                  v-for="count in fetchRouteTickets(completeList, true, false)"
                  :value="count.ticketCode"
                >
                  {{ count.ticketName }}
                </option>
              </select>
            </div>

            <div class="col-md-4 mb-3" v-if="!isDonate && !isSponsor">
              <label
                class="mt-3"
                style="
                  font-family: 'Wix Madefor Text', sans-serif;
                  font-weight: 400;
                  font-size: 1.2em;
                  color: black;
                "
                >Number of Ticket(s)</label
              >

              <select class="form-control" v-model="tickcount">
                <option
                  class="form-control"
                  v-bind:key="count + 'b'"
                  v-for="count in tickcountlist"
                  :value="count"
                >
                  {{ count }}
                </option>

                <option
                  disabled
                  v-if="
                    tickcountlist.length == 0 &&
                    initvalue[daylist.ticketCode] != 0
                  "
                >
                  Max Amount Reached
                </option>

                <option disabled v-if="initvalue[daylist.ticketCode] == 0">
                  Sold Out
                </option>
              </select>
            </div>

            <div
              class="col-md-4 mt-4 text-center"
              v-if="!isDonate && !isSponsor"
            >
              <p>
                <b
                  class="font-weight-bold"
                  style="
                    font-family: 'Wix Madefor Text', sans-serif;
                    font-weight: 400;
                    font-size: 1.2em;
                    color: black;
                  "
                  >Per Person:</b
                >
                ${{
                  !redeemData
                    ? ttypelist && ttypelist.price
                      ? ttypelist.price.toFixed(2)
                      : "0.00"
                    : redeemData.price.toFixed(2)
                }}
              </p>
              <p v-if="!redeemData">
                <b
                  class="font-weight-bold"
                  style="
                    font-family: 'Wix Madefor Text', sans-serif;
                    font-weight: 400;
                    font-size: 1.2em;
                    color: black;
                  "
                  >Total Amount:</b
                >

                ${{
                  (
                    (ttypelist && ttypelist.price ? ttypelist.price || 0 : 0) *
                    (tickcount || 0)
                  ).toFixed(2)
                }}
              </p>
              <p v-if="redeemData">
                <b
                  class="font-weight-bold"
                  style="
                    font-family: 'Wix Madefor Text', sans-serif;
                    font-weight: 400;
                    font-size: 1.2em;
                    color: black;
                  "
                  >Total Amount:</b
                >
                ${{
                  (
                    (redeemData ? redeemData.price || 0 : 0) * (tickcount || 0)
                  ).toFixed(2)
                }}
              </p>
            </div>

            <div
              class="col-md-3"
              v-if="
                TicketsResult[selected] &&
                isDonate == false &&
                isSponsor == false &&
                TicketsResult[selected].discount
              "
            ></div>

            <div
              class="col-md-6 mt-3 text-center"
              v-if="
                TicketsResult[selected] &&
                isDonate == false &&
                isSponsor == false &&
                TicketsResult[selected].discount
              "
            >
              <label
                class=""
                style="
                  font-family: 'Wix Madefor Text', sans-serif;
                  font-weight: 400;
                  font-size: 1.2em;
                  color: black;
                "
                >Do you have a promo code?</label
              >

              <input
                type="text"
                v-model="redeempromo"
                class="form-control"
                placeholder="Promo code"
              />

              <button
                type="button"
                @click="redeem('daylist')"
                :disabled="!redeempromo.trim().length"
                class="btn solid-btn-Entrepreneurship btn-sm my-auto"
                id="reserve"
                style="
                  pointer-events: all;
                  cursor: pointer;
                  padding: 7px;
                  margin-top: 11px !important;
                "
              >
                Redeem Code
              </button>
            </div>

            <div
              class="col-md-3 text-center"
              id="redeem"
              v-if="
                TicketsResult[selected] &&
                isDonate == false &&
                isSponsor == false &&
                TicketsResult[selected].discount
              "
            ></div>

            <div
              v-if="!isDonate && !isSponsor"
              class="col-md-12 text-center my-4"
            >
              <input
                type="button"
                @click="addtocart('daylist')"
                class="btn solid-btn-Entrepreneurship m-auto mr-2"
                :disabled="!daylist || !tickcount"
                value="Add to cart"
                style="
                  pointer-events: all;
                  cursor: pointer;
                  font-family: 'Wix Madefor Text', sans-serif;
                  font-weight: 700;
                  font-size: 1.2em;
                  font-weight: bold;
                "
              />
            </div>

            <hr v-if="isDonate" class="w-100 p-2" />
            <!-- Ticket Options -->

            <!-- Donation Options -->
            <div v-if="isDonate" class="col-md-12 mb-3">
              <div class="text-center">
                <span
                  class="w-auto d-inline-block"
                  style="
                    font-family: 'Wix Madefor Text', sans-serif;
                    font-weight: 700;
                    font-size: 2.2em;
                    color: #000000;
                  "
                >
                  Vendor Registration(s)
                </span>
              </div>
            </div>

            <div v-if="isDonate" class="col-md-4">
              <label
                class="mt-3 labels"
                style="
                  font-family: 'Wix Madefor Text', sans-serif;
                  font-weight: 400;
                  font-size: 1.2em;
                  color: black;
                "
                >Registration Type</label
              >
              <select
                @change="
                  (e) => {
                    redeemData = null;
                    redeempromo = '';
                    dayChange('daylist1', e.target.value);
                  }
                "
                class="form-control"
                v-model="daylisty"
              >
                <option
                  class="form-control"
                  v-bind:key="count + 'b'"
                  v-for="count in fetchRouteTickets(completeList, false, true)"
                  :value="count.ticketCode"
                >
                  {{ count.ticketName }}
                </option>
              </select>
            </div>

            <div v-if="isDonate" class="col-md-4 mb-3">
              <label
                class="mt-3"
                style="
                  font-family: 'Wix Madefor Text', sans-serif;
                  font-weight: 400;
                  font-size: 1.2em;
                  color: black;
                "
                >Number of Registration(s)</label
              >
              <select class="form-control" v-model="tickcount1">
                <option
                  class="form-control"
                  v-bind:key="count + 'b'"
                  v-for="count in tickcountlist1"
                  :value="count"
                >
                  {{ count }}
                </option>

                <option
                  disabled
                  v-if="
                    tickcountlist1.length == 0 &&
                    initvalue[daylist1.ticketCode] != 0
                  "
                >
                  No more vendor registration
                </option>

                <option disabled v-if="initvalue[daylist1.ticketCode] == 0">
                  Sold Out
                </option>
              </select>
            </div>

            <div v-if="isDonate" class="col-md-4 mt-4 text-center">
              <p>
                <b
                  class="font-weight-bold"
                  style="
                    font-family: 'Wix Madefor Text', sans-serif;
                    font-weight: 400;
                    font-size: 1.2em;
                    color: black;
                  "
                >
                  Per Amount:</b
                >
                ${{
                  !redeemData
                    ? ttypelist1 && ttypelist1.price
                      ? ttypelist1.price.toFixed(2)
                      : "0.00"
                    : redeemData.price.toFixed(2)
                }}
              </p>
              <p>
                <b
                  class="font-weight-bold"
                  style="
                    font-family: 'Wix Madefor Text', sans-serif;
                    font-weight: 400;
                    font-size: 1.2em;
                    color: black;
                  "
                  >Total Amount:</b
                >
                ${{
                  (
                    (ttypelist1 && ttypelist1.price
                      ? ttypelist1.price || 0
                      : 0) * (tickcount1 || 0)
                  ).toFixed(2)
                }}
              </p>
            </div>

            <div
              class="col-md-3"
              v-if="
                TicketsResult[selected] &&
                isDonate == true &&
                TicketsResult[selected].discount
              "
            ></div>

            <div
              class="col-md-6 mt-3 text-center"
              v-if="
                TicketsResult[selected] &&
                isDonate == true &&
                TicketsResult[selected].discount
              "
            >
              <label
                class=""
                style="
                  font-family: 'Wix Madefor Text', sans-serif;
                  font-weight: 400;
                  font-size: 1.2em;
                  color: black;
                "
                >Do you have a promo code?</label
              >

              <input
                type="text"
                v-model="redeempromo"
                class="form-control"
                placeholder="Promo code"
              />

              <button
                type="button"
                @click="redeem('daylist1')"
                :disabled="!redeempromo.trim().length"
                class="btn solid-btn-Entrepreneurship btn-sm my-auto"
                id="reserve"
                style="
                  pointer-events: all;
                  cursor: pointer;
                  padding: 7px;
                  margin-top: 11px !important;
                "
              >
                Redeem Code
              </button>
            </div>

            <div
              class="col-md-3 text-center"
              id="redeem"
              v-if="
                TicketsResult[selected] &&
                isDonate == true &&
                TicketsResult[selected].discount
              "
            ></div>

            <div v-if="isDonate" class="col-md-12 text-center my-4">
              <input
                type="button"
                @click="addtocart('daylist1')"
                class="btn solid-btn-Entrepreneurship m-auto mr-2"
                :disabled="!daylist1 || !tickcount1"
                value="Add To Cart"
                style="
                  pointer-events: all;
                  cursor: pointer;
                  font-family: 'Wix Madefor Text', sans-serif;
                  font-weight: 700;
                  font-size: 1.2em;
                  font-weight: bold;
                "
              />
            </div>

            <!-- Donation Options -->
            <div v-if="isSponsor" class="col-md-12 mb-3">
              <div class="text-center">
                <span
                  class="w-auto d-inline-block"
                  style="
                    font-family: 'Wix Madefor Text', sans-serif;
                    font-weight: 700;
                    font-size: 2.2em;
                    color: #000000;
                  "
                >
                  Sponsorship Registration(s)
                </span>
              </div>
            </div>

            <div v-if="isSponsor" class="col-md-4">
              <label
                class="mt-3 labels"
                style="
                  font-family: 'Wix Madefor Text', sans-serif;
                  font-weight: 500;
                  font-size: 1.2em;
                  color: black;
                "
                >Sponsorship Type</label
              >
              <select
                @change="
                  (e) => {
                    redeemData = null;
                    redeempromo = '';
                    dayChange('daylist1', e.target.value);
                  }
                "
                class="form-control"
                v-model="daylist12"
              >
                <option
                  class="form-control"
                  v-bind:key="count + 'ab'"
                  v-for="count in fetchRouteTickets(completeList, false, false)"
                  :value="count.ticketCode"
                >
                  {{ count.ticketName }}
                </option>
              </select>
            </div>

            <div v-if="isSponsor" class="col-md-4 mb-3">
              <label
                class="mt-3"
                style="
                  font-family: 'Wix Madefor Text', sans-serif;
                  font-weight: 500;
                  font-size: 1.2em;
                  color: black;
                "
                >Number of Sponsorship(s)</label
              >
              <select class="form-control" v-model="tickcount1">
                <option
                  class="form-control"
                  v-bind:key="count + 'b'"
                  v-for="count in tickcountlist1"
                  :value="count"
                >
                  {{ count }}
                </option>

                <option
                  disabled
                  v-if="
                    tickcountlist1.length == 0 &&
                    initvalue[daylist1.ticketCode] != 0
                  "
                >
                  No more sponsorship registration
                </option>

                <option disabled v-if="initvalue[daylist1.ticketCode] == 0">
                  Sold Out
                </option>
              </select>
            </div>

            <div v-if="isSponsor" class="col-md-4 mt-4 text-center">
              <p>
                <b
                  class="font-weight-bold"
                  style="
                    font-family: 'Wix Madefor Text', sans-serif;
                    font-weight: 500;
                    font-size: 1.2em;
                    color: black;
                  "
                >
                  Per Amount:</b
                >
                ${{
                  !redeemData
                    ? ttypelist1 && ttypelist1.price
                      ? ttypelist1.price.toFixed(2)
                      : "0.00"
                    : redeemData.price.toFixed(2)
                }}
              </p>
              <p>
                <b
                  class="font-weight-bold"
                  style="
                    font-family: 'Wix Madefor Text', sans-serif;
                    font-weight: 500;
                    font-size: 1.2em;
                    color: black;
                  "
                  >Total Amount:</b
                >
                ${{
                  (
                    (ttypelist1 && ttypelist1.price
                      ? ttypelist1.price || 0
                      : 0) * (tickcount1 || 0)
                  ).toFixed(2)
                }}
              </p>
            </div>

            <div
              class="col-md-3"
              v-if="
                TicketsResult[selected] &&
                isSponsor == true &&
                TicketsResult[selected].discount
              "
            ></div>

            <div
              class="col-md-3 text-center"
              id="redeem"
              v-if="
                TicketsResult[selected] &&
                isSponsor == true &&
                TicketsResult[selected].discount
              "
            ></div>

            <div v-if="isSponsor" class="col-md-12 text-center my-4">
              <input
                type="button"
                @click="addtocart('daylist1')"
                class="btn solid-btn-Entrepreneurship m-auto mr-2"
                :disabled="!daylist1 || !tickcount1"
                value="Add To Cart"
                style="
                  pointer-events: all;
                  cursor: pointer;
                  font-family: 'Wix Madefor Text', sans-serif;
                  font-weight: 700;
                  font-size: 1.2em;
                  font-weight: bold;
                "
              />
            </div>

            <hr class="w-100 p-2" />
            <!-- Ticket Options -->

            <!-- Cart details -->
            <div class="col-md-12">
              <div class="text-center">
                <h4
                  class="w-auto d-inline-block"
                  style="
                    font-family: 'Wix Madefor Text', sans-serif;
                    font-weight: 700;
                    font-size: 2.2em;
                    color: #000000;
                  "
                >
                  Cart Details
                </h4>
              </div>
            </div>

            <div class="col-md-12">
              <table style="width: 100%">
                <thead>
                  <tr>
                    <th
                      style="
                        font-family: 'Wix Madefor Text', sans-serif;
                        font-weight: 600;
                        font-size: 1.3em;
                        color: black;
                      "
                    >
                      Selected item(s)
                    </th>
                    <th
                      style="
                        font-family: 'Wix Madefor Text', sans-serif;
                        font-weight: 600;
                        font-size: 1.3em;
                        color: black;
                        text-align: center;
                      "
                    >
                      Quantity
                    </th>
                    <th
                      style="
                        font-family: 'Wix Madefor Text', sans-serif;
                        font-weight: 600;
                        font-size: 1.3em;
                        color: black;
                        text-align: center;
                      "
                    >
                      Amount
                    </th>
                    <th></th>
                  </tr>
                </thead>
                <tbody>
                  <tr v-for="(r, i) in selectedCarts" v-bind:key="r">
                    <td
                      style="
                        width: 60%;
                        font-family: 'Wix Madefor Text', sans-serif;
                        font-weight: 500;
                        font-size: 1.2em;
                        color: black;
                      "
                    >
                      <p>{{ r.ticketName }}</p>
                    </td>
                    <td
                      style="
                        width: 15%;
                        text-align: center;
                        font-family: 'Wix Madefor Text', sans-serif;
                        font-weight: 500;
                        font-size: 1.2em;
                        color: black;
                      "
                    >
                      <p>{{ r.tttcount }}</p>
                    </td>
                    <td
                      style="
                        width: 15%;
                        text-align: center;
                        font-family: 'Wix Madefor Text', sans-serif;
                        font-weight: 500;
                        font-size: 1.2em;
                        color: black;
                      "
                    >
                      <p>${{ (r.tttcount * r.price).toFixed(2) }}</p>
                    </td>
                    <td style="width: 10%; text-align: right; cursor: pointer">
                      <p>
                        <span
                          @click="deleteRec(r, i)"
                          style="
                            color: #d90606;
                            display: block;
                            font-weight: bold;
                            font-family: 'Wix Madefor Text';
                          "
                        >
                          X</span
                        >
                      </p>
                    </td>
                  </tr>
                  <tr v-if="selectedCarts.length == 0">
                    <td
                      colSpan="4"
                      style="
                        padding-top: 20px;
                        font-family: 'Wix Madefor Text', sans-serif;
                        font-weight: 500;
                        font-size: 1.1em;
                        color: grey;
                      "
                    >
                      <p class="text-center">No Ticket(s) / Sponsorship(s)</p>
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>

            <!-- Cart details -->

            <div
              class="row col-md-12 m-auto mt-4 w-100 p-0 pb-4"
              v-if="
                false && section1.includes(TicketsResult[selected].ticketCode)
              "
            >
              <div class="col-md-6">
                <input
                  type="text"
                  v-model="ePhoneNumber"
                  class="form-control"
                  placeholder="Phone Number"
                />
              </div>
              <div class="col-md-6">
                <input
                  type="text"
                  v-model="eOrgNumber"
                  class="form-control"
                  placeholder="Organization Or Institution: ex: DEPA (if applicable)"
                />
              </div>
            </div>

            <hr
              class="w-100 p-2"
              v-if="
                TicketsResult[selected] &&
                section2.includes(TicketsResult[selected].ticketCode)
              "
            />
            <div
              class="row"
              v-if="
                TicketsResult[selected] &&
                section2.includes(TicketsResult[selected].ticketCode)
              "
            >
              <div class="col-md-6 mb-2">
                <label class="">Name of Business/Individual</label>
                <input
                  type="text"
                  v-model="nameOfBusiness"
                  class="form-control"
                  placeholder="Name of Business/Individual"
                />
              </div>
              <div class="col-md-6 mb-2">
                <label class="">Address</label>
                <input
                  type="text"
                  v-model="address"
                  class="form-control"
                  placeholder="Address"
                />
              </div>
              <div class="col-md-6 mb-2">
                <label class="">City, State, Zip</label>
                <input
                  type="text"
                  v-model="cityStateZip"
                  class="form-control"
                  placeholder="City, State, Zip"
                />
              </div>
              <div class="col-md-6 mb-2">
                <label class="">Contact Person</label>
                <input
                  type="text"
                  v-model="contactPerson"
                  class="form-control"
                  placeholder="Contact Person"
                />
              </div>

              <div class="col-md-6 mb-2">
                <label class="">Contact Number</label>
                <input
                  type="text"
                  v-model="telephoneNumber"
                  class="form-control"
                  placeholder="Contact Number"
                />
              </div>
              <div class="col-md-6 mb-2">
                <label class="">Email Address</label>
                <input
                  type="text"
                  v-model="emailAddress"
                  class="form-control"
                  placeholder="Email Address"
                />
              </div>
            </div>

            <div
              class="col-md-12 mt-4"
              style="
                font-family: 'Wix Madefor Text', sans-serif;
                font-weight: 500;
                font-size: 1.1em;
                color: black;
              "
            >
              <input type="checkbox" v-model="reserveFormAccept" />
              I understand that all sales are final. No refunds. I have read and
              agree with the MYLE
              <a
                href="https://myle.com/terms"
                target="_blank"
                rel="noopener noreferrer"
              >
                terms and conditions.</a
              >
            </div>

            <!-- <div
              class="col-md-12 mt-3"
              style="
                font-family: 'Wix Madefor Text', sans-serif;
                font-size: 1.1em;
                font-weight: 500;
                color: black;
              "
            >
              <input
                type="checkbox"
                v-model="reserveFormAcceptAboutSurveyOptIn"
              />
              May we contact you for any additional events held by REACT?
            </div> -->

            <div class="col-md-12 text-center mt-4">
              <button
                type="submit"
                @click="paynowcustom()"
                :disabled="
                  !fullname.trim().length ||
                  !interested.trim().length ||
                  !invalidemail ||
                  !invaliduphone ||
                  isSubmitted ||
                  !selectedCarts.length ||
                  !reserveFormAccept
                "
                class="btn solid-btn-Entrepreneurship m-auto mr-2"
                style="
                  pointer-events: all;
                  cursor: pointer;
                  font-family: 'Wix Madefor Text', sans-serif;
                  font-weight: 700;
                  font-size: 1.2em;
                  font-weight: bold;
                "
              >
                Buy Now
              </button>
            </div>
          </div>
        </div>
      </form>
    </nu-modal>
    <!-- form ends -->

    <div class="container-fluid p-0" style="overflow-x: hidden">
      <!-- Navbar section starts -->
      <div class="row">
        <div class="col-md-12">
          <nav-bar />
        </div>
      </div>
      <!-- Navbar section ends -->
      <!-- banner section starts -->
      <div class="row text-center">
        <div class="col-md-12" id="banner">
          <img
            class="align-middle"
            src="https://storage.googleapis.com/wnk1yeeawadm9lfc8qu5ctszt99ghpd1rqh1p7w71bhqiaqfl0tasz1y525o/mylesite/header_AITheFutureOfEntrepreneurship_V3.png"
            style="
              width: 100%;
              max-width: 100%;
              height: auto;
              margin-top: 4.6rem;
            "
          />
        </div>
      </div>
      <!-- banner section ends -->
      <div
        class="row w-100 m-0 promo-section MYLE-lite-green"
        style="background-color: #000000; border-top: 1px solid white"
      >
        <div class="col-lg-12 col-md-12">
          <div class="mt-4">
            <div class="section-heading mb-4">
              <h1
                class="text-center"
                style="
                  font-family: 'Wix Madefor Text', sans-serif;
                  font-weight: 500;
                  font-size: 2.8em;
                  color: #ffffff;
                "
              >
                AI & The Future of Entrepreneurship
              </h1>

              <!-- <h1
                class="text-center"
                style="
                  font-family: 'Wix Madefor Text', sans-serif;
                  font-weight: 400;
                  font-size: 1.05em;
                  color: #ffee00;
                "
              >
                🗓️ Saturday, June 07, 2025
                <br />
                🕐 1:00 PM – 6:00 PM
              </h1>

              <h1
                class="text-center"
                style="
                  font-family: 'Wix Madefor Text', sans-serif;
                  font-weight: 500;
                  font-size: 1.05em;
                  color: #ffee00;
                "
              >
                <a
                  href="https://maps.app.goo.gl/ePWw9tEHRhoXkEdVA"
                  target="_blank"
                  rel="noopener noreferrer"
                  style="color: #ffee00"
                >
                  📍 Plywood People - Atlanta
                </a>
              </h1> -->
            </div>
          </div>
        </div>
      </div>

      <!-- Description section starts -->
      <div
        class="row align-items-center justify-content-between test"
        style="margin: auto; margin-top: 20px"
      >
        <div class="col-md-12">
          <div class="col-md-12">
            <div class="download-content mt-2" id="ban1">
              <p
                class="text-center"
                style="
                  font-family: 'Wix Madefor Text', sans-serif;
                  font-weight: 500;
                  font-size: 1.6em;
                  color: #110f0f;
                  letter-spacing: 0.1em;
                "
              >
                Atlanta's Entrepreneurial Landscape is About to Be Rewired by AI
                - Powered by Watson Institute and Truist Foundation one of the
                fellows bring innovation with "AI & The Future of
                Entrepreneurship" Symposium
              </p>

              <p
                class="mt-5"
                style="
                  font-family: 'Wix Madefor Text', sans-serif;
                  font-weight: 400;
                  font-size: 1.4em;
                  color: #110f0f;
                "
              >
                <span
                  style="
                    font-family: 'Wix Madefor Text', sans-serif;
                    font-size: 1.6em;
                    font-weight: 400;
                    color: #110f0f;
                  "
                >
                  EVENT DETAILS:
                </span>

                <br />

                <span style="font-weight: 400; font-size: 0.9em">
                  🗓️ <span class="bolded"> Date:</span> June 7, 2025
                  <br />
                  🕐 <span class="bolded"> Time:</span> 1:00 PM <br />
                  📍 <span class="bolded"> Event Location:</span>
                  <a
                    href="https://maps.app.goo.gl/ePWw9tEHRhoXkEdVA"
                    target="_blank"
                    rel="noopener noreferrer"
                    style="color: black"
                  >
                    Plywood People, Atlanta
                  </a>
                </span>
              </p>

              <div class="container text-center mt-5" style="width: 100%">
                <div class="player-container">
                  <video-player ref="videoPlayer" :options="options1">
                  </video-player>
                </div>
              </div>
              <br />
              <br />
              <p
                class=""
                style="
                  font-family: 'Wix Madefor Text', sans-serif;
                  font-size: 1.6em;
                  color: #000000;
                "
              >
                <button
                  class="btn solid-btn-Entrepreneurship text-center shimmer"
                  @click="openmodelmyle(false, false)"
                  style="
                    pointer-events: all;
                    cursor: pointer;
                    margin: auto;
                    display: block;
                    font-family: 'Wix Madefor Text', sans-serif;
                    font-weight: 700;
                    font-size: 1em;
                    font-weight: bold;
                  "
                >
                  Get Tickets
                </button>
              </p>

              <p
                class="text-center"
                style="
                  font-family: 'Wix Madefor Text', sans-serif;
                  font-weight: 400;
                  font-size: 1.1em;
                  color: #110f0f;
                "
              >
                First 30 Tickets will Receive Swag Bags
                <br />
                <br />
                Almost Doesnt Count but you made it - Next 30 Tickets will be
                entered into a raffle to receive Free PR Services (30 days)

                <br />
                <br />
                Tardy for the Party but we are Showing you Grace - Last 30
                Tickets will be entered into a raffle to receive Free AI &
                Digital Marketing Services (30 days)
                <br />
              </p>

              <hr />
              <br />

              <p
                class=""
                style="
                  font-family: 'Wix Madefor Text', sans-serif;
                  font-weight: 400;
                  font-size: 1.4em;
                  color: #110f0f;
                "
                id="d16"
              >
                <span
                  style="
                    font-family: 'Wix Madefor Text', sans-serif;
                    font-size: 1.6em;
                    font-weight: 400;
                    color: #110f0f;
                  "
                >
                  WHY ATTEND?
                </span>

                <br />
                <br />

                <span
                  style="
                    font-family: 'Wix Madefor Text', sans-serif;
                    font-weight: 400;
                    font-size: 0.9em;
                  "
                >
                  <span
                    style="
                      font-family: 'Wix Madefor Text', sans-serif;
                      font-size: 1.2em;
                      font-weight: 400;
                      color: #110f0f;
                    "
                  >
                    🌟 Gain Cutting-Edge Insights:
                  </span>
                  <br />
                  Discover how AI is transforming industries and unlocking new
                  entrepreneurial opportunities.
                  <br /><br />
                  <span
                    style="
                      font-family: 'Wix Madefor Text', sans-serif;
                      font-size: 1.2em;
                      font-weight: 400;
                      color: #110f0f;
                    "
                    >🌟 Learn from Leading Experts:</span
                  ><br />
                  Hear from subject matter experts including a Procurement
                  Manager, Lawyer, Investors, Venture Capitalists, Financial
                  Planners, and visionary thought leaders like the legendary Ray
                  Daniels!
                  <br /><br />
                  <span
                    style="
                      font-family: 'Wix Madefor Text', sans-serif;
                      font-size: 1.2em;
                      font-weight: 400;
                      color: #110f0f;
                    "
                    >🌟 Exclusive Networking:</span
                  ><br />
                  Connect with fellow entrepreneurs, potential collaborators,
                  investors, and the esteemed speakers.
                  <br /><br />
                  <span
                    style="
                      font-family: 'Wix Madefor Text', sans-serif;
                      font-size: 1.2em;
                      font-weight: 400;
                      color: #110f0f;
                    "
                    >🌟 Unlock Growth Opportunities:</span
                  ><br />
                  Gain actionable strategies to integrate AI into your business
                  and navigate the future of entrepreneurship.
                </span>
              </p>
              <br />

              <br />

              <p
                class="text-center"
                style="
                  font-family: 'Wix Madefor Text', sans-serif;
                  font-weight: 700;
                  font-size: 1.8em;
                  color: #110f0f;
                "
                id="d16"
              >
                Limited Capacity – Don’t Miss Out!
              </p>
              <hr />
              <br />

              <p
                class="mb-2"
                style="
                  font-family: 'Wix Madefor Text', sans-serif;
                  font-weight: 400;
                  font-size: 1.4em;
                  color: #110f0f;
                  display: block;
                "
              >
                <span
                  style="
                    font-family: 'Wix Madefor Text', sans-serif;
                    font-size: 1.6em;
                    font-weight: 400;
                    color: #110f0f;
                  "
                >
                  🚨 EARLY BIRD ALERT!
                </span>
              </p>
              <div class="row mt-0" id="d15">
                <div
                  class="col-md-12 col-md-12"
                  style="font-family: 'Montserrat', sans-serif"
                >
                  <p
                    class=""
                    style="
                      font-family: 'Wix Madefor Text', sans-serif;
                      font-weight: 400;
                      font-size: 1.4em;
                      color: #110f0f;
                    "
                  >
                    <span
                      style="
                        font-family: 'Wix Madefor Text', sans-serif;
                        font-weight: 400;
                        font-size: 0.9em;
                      "
                    >
                      Only the first 30 to Register will receive a Swag Bag
                    </span>
                  </p>
                </div>
              </div>

              <br />
              <br />

              <p
                class="mb-2"
                style="
                  font-family: 'Wix Madefor Text', sans-serif;
                  font-weight: 400;
                  font-size: 1.4em;
                  color: #110f0f;
                  display: block;
                "
              >
                <span
                  style="
                    font-family: 'Wix Madefor Text', sans-serif;
                    font-size: 1.6em;
                    font-weight: 400;
                    color: #110f0f;
                  "
                >
                  👥 Intimate Setting:
                </span>
              </p>
              <div class="row mt-0" id="d15">
                <div
                  class="col-md-12 col-md-12"
                  style="font-family: 'Montserrat', sans-serif"
                >
                  <p
                    class=""
                    style="
                      font-family: 'Wix Madefor Text', sans-serif;
                      font-weight: 400;
                      font-size: 1.4em;
                      color: #110f0f;
                    "
                  >
                    <span
                      style="
                        font-family: 'Wix Madefor Text', sans-serif;
                        font-weight: 400;
                        font-size: 0.9em;
                      "
                    >
                      This is an exclusive event with a maximum capacity of only
                      100 people, ensuring valuable connections and focused
                      discussions.
                    </span>
                  </p>
                  <br />
                  <br />
                  <p
                    class=""
                    style="
                      font-family: 'Wix Madefor Text', sans-serif;
                      font-weight: 400;
                      font-size: 1.4em;
                      color: #110f0f;
                    "
                    id="d16"
                  >
                    <span
                      style="
                        font-family: 'Wix Madefor Text', sans-serif;
                        font-size: 1.6em;
                        font-weight: 400;
                        color: #110f0f;
                      "
                    >
                      Exclusive Perks & Opportunities:
                    </span>

                    <br />
                    <br />

                    <span
                      style="
                        font-family: 'Wix Madefor Text', sans-serif;
                        font-weight: 400;
                        font-size: 0.9em;
                      "
                    >
                      <span
                        style="
                          font-family: 'Wix Madefor Text', sans-serif;
                          font-size: 1.2em;
                          font-weight: 400;
                          color: #110f0f;
                        "
                      >
                        👗 Personal Stylist Makeover:
                      </span>
                      <br />
                      Be entered in to a raffle for complimentary personal
                      stylist makeover when you register before 5.23

                      <br /><br />
                      <span
                        style="
                          font-family: 'Wix Madefor Text', sans-serif;
                          font-size: 1.2em;
                          font-weight: 400;
                          color: #110f0f;
                        "
                        >🚀 Win Big for Your Business: </span
                      ><br />
                      One business in attendance will receive 30 DAYS WORTH OF
                      FREE PR SERVICES to elevate your brand! One business in
                      attendance will receive 30 DAYS WORTH OF FREE AI & DIGITAL
                      MARKETING SERVICES to create a digital imprint online to
                      increase your visibility and exposure

                      <br /><br />
                      <span
                        style="
                          font-family: 'Wix Madefor Text', sans-serif;
                          font-size: 1.2em;
                          font-weight: 400;
                          color: #110f0f;
                        "
                        >🎯 Sponsorship Opportunities: </span
                      ><br />
                      Position your brand alongside the Truist Foundation and
                      the Watson Institute! Showcase your organization to a
                      targeted audience and gain significant visibility on print
                      collateral and our event step-and-repeat.
                    </span>
                  </p>

                  <hr />
                  <br />

                  <div class="row text-center" id="tickets">
                    <div
                      class="col-md-12 col-md-12"
                      style="font-family: 'Montserrat', sans-serif"
                    >
                      <p
                        class="text-center"
                        style="
                          font-family: 'Cinzel Decorative', sans-serif;
                          font-size: 1.6em;
                          font-weight: 700;
                          color: #eae492;
                        "
                      >
                        <span
                          style="
                            font-family: 'Wix Madefor Display', sans-serif;
                            font-size: 1.6em;
                            font-weight: 700;
                            color: #110f0f;
                          "
                        >
                          SPONSORSHIP OPTIONS
                        </span>
                      </p>

                      <p
                        class=""
                        style="
                          font-family: 'Wix Madefor Text', sans-serif;
                          font-size: 1.6em;
                          color: #000000;
                        "
                      >
                        <button
                          class="btn solid-btn-Entrepreneurship text-center shimmer"
                          @click="openmodelmyle(false, true)"
                          style="
                            pointer-events: all;
                            cursor: pointer;
                            margin: auto;
                            display: block;
                            font-family: 'Wix Madefor Text', sans-serif;
                            font-weight: 700;
                            font-size: 1em;
                            font-weight: bold;
                          "
                        >
                          Get Sponsorship
                        </button>
                      </p>
                    </div>
                  </div>

                  <div class="row justify-content-center text-center mt-5">
                    <div
                      class="col-12 col-md-12 justify-content-center d-flex align-items-center"
                    >
                      <div class="">
                        <img
                          src="https://storage.googleapis.com/wnk1yeeawadm9lfc8qu5ctszt99ghpd1rqh1p7w71bhqiaqfl0tasz1y525o/mylesite/flyer_AITheFutureOfEntrepreneurship_Sponsorship_Package_V2.png"
                          alt="Slow Jam Social Event"
                          class="w-50 img-fluid"
                        />
                      </div>
                    </div>
                  </div>

                  <div class="row justify-content-center text-center mt-5">
                    <div
                      class="col-6 col-md-6 justify-content-center d-flex align-items-center"
                    >
                      <div class="">
                        <img
                          src="https://storage.googleapis.com/wnk1yeeawadm9lfc8qu5ctszt99ghpd1rqh1p7w71bhqiaqfl0tasz1y525o/mylesite/img_flyer_AITheFutureOfEntrepreneurship_Anderson.png"
                          alt="Slow Jam Social Event"
                          class="w-100 img-fluid"
                        />
                      </div>
                    </div>

                    <div
                      class="col-6 col-md-6 justify-content-center d-flex align-items-center"
                    >
                      <div class="">
                        <img
                          src="https://storage.googleapis.com/wnk1yeeawadm9lfc8qu5ctszt99ghpd1rqh1p7w71bhqiaqfl0tasz1y525o/mylesite/img_flyer_AITheFutureOfEntrepreneurship_Richard_Dunn.png"
                          alt="Slow Jam Social Event"
                          class="w-100 img-fluid"
                        />
                      </div>
                    </div>
                  </div>
                  <!-- 
                  <div class="row justify-content-center text-center mt-5">
                    <div
                      class="col-6 col-md-6 justify-content-center d-flex align-items-center"
                    >
                      <div class="">
                        <img
                          src="https://storage.googleapis.com/wnk1yeeawadm9lfc8qu5ctszt99ghpd1rqh1p7w71bhqiaqfl0tasz1y525o/mylesite/img_flyer_AITheFutureOfEntrepreneurship_Dr_Natasha_Weems_MEKKA.jpg"
                          alt="Slow Jam Social Event"
                          class="w-100 img-fluid"
                        />
                      </div>
                    </div>

                    <div
                      class="col-6 col-md-6 justify-content-center d-flex align-items-center"
                    >
                      <div class="">
                        <img
                          src="https://storage.googleapis.com/wnk1yeeawadm9lfc8qu5ctszt99ghpd1rqh1p7w71bhqiaqfl0tasz1y525o/mylesite/img_flyer_AITheFutureOfEntrepreneurship_Marcel_Mendoza_MEKKA_V1.jpg"
                          alt="Slow Jam Social Event"
                          class="w-100 img-fluid"
                        />
                      </div>
                    </div>
                  </div> -->

                  <br />
                  <br />

                  <p
                    class="mb-2"
                    style="
                      font-family: 'Wix Madefor Text', sans-serif;
                      font-weight: 400;
                      font-size: 1.4em;
                      color: #110f0f;
                      display: block;
                    "
                  >
                    <span
                      style="
                        font-family: 'Wix Madefor Text', sans-serif;
                        font-size: 1.6em;
                        font-weight: 400;
                        color: #110f0f;
                      "
                    >
                      Connect With:
                    </span>
                  </p>
                  <div class="row mt-0" id="d15">
                    <div
                      class="col-md-12 col-md-12"
                      style="font-family: 'Montserrat', sans-serif"
                    >
                      <p
                        class=""
                        style="
                          font-family: 'Wix Madefor Text', sans-serif;
                          font-weight: 400;
                          font-size: 1.4em;
                          color: #110f0f;
                        "
                      >
                        <span
                          style="
                            font-family: 'Wix Madefor Text', sans-serif;
                            font-weight: 400;
                            font-size: 0.9em;
                          "
                        >
                          🎵 Special Expert Guest<br />
                          💼 Procurement Manager: Lazerick Russell (Invest
                          Atlanta) <br />
                          🤖 AI Expert: Weston Quintrell - Founder at Marketing
                          Titan <br />
                          💰 Investors & Venture Capitalists: Network with
                          individuals actively funding the future of innovation.
                          <br />
                          📈 Licensed Financial Planner: Gain insights into
                          managing finances in an AI-driven economy. <br />
                          🔑 And Many More Thought Leaders! <br />
                        </span>
                      </p>
                    </div>
                  </div>
                  <br />
                  <br />

                  <p
                    class="mb-2"
                    style="
                      font-family: 'Wix Madefor Text', sans-serif;
                      font-weight: 400;
                      font-size: 1.4em;
                      color: #110f0f;
                      display: block;
                    "
                  >
                    <span
                      style="
                        font-family: 'Wix Madefor Text', sans-serif;
                        font-size: 1.6em;
                        font-weight: 400;
                        color: #110f0f;
                      "
                    >
                      🔗 Follow Us for Updates:
                    </span>
                  </p>
                  <div class="row mt-0" id="d15">
                    <div
                      class="col-md-12 col-md-12"
                      style="font-family: 'Montserrat', sans-serif"
                    >
                      <p
                        class=""
                        style="
                          font-family: 'Wix Madefor Text', sans-serif;
                          font-weight: 400;
                          font-size: 1.4em;
                          color: #110f0f;
                        "
                      >
                        <span
                          style="
                            font-family: 'Wix Madefor Text', sans-serif;
                            font-weight: 400;
                            font-size: 0.9em;
                          "
                        >
                          @CorporateChics | LinkedIn: TNecoleGibbs
                        </span>
                      </p>
                    </div>
                  </div>
                </div>
              </div>

              <br />
              <hr />
              <br />

              <div class="row text-center" id="tickets">
                <div
                  class="col-md-12 col-md-12"
                  style="font-family: 'Montserrat', sans-serif"
                >
                  <p
                    class="text-center"
                    style="
                      font-family: 'Cinzel Decorative', sans-serif;
                      font-size: 1.6em;
                      font-weight: 700;
                      color: #eae492;
                    "
                  >
                    <span
                      style="
                        font-family: 'Wix Madefor Display', sans-serif;
                        font-size: 1.6em;
                        font-weight: 700;
                        color: #110f0f;
                      "
                    >
                      TICKET OPTIONS
                    </span>
                  </p>

                  <p
                    class=""
                    style="
                      font-family: 'Wix Madefor Text', sans-serif;
                      font-size: 1.6em;
                      color: #000000;
                    "
                  >
                    <button
                      class="btn solid-btn-Entrepreneurship text-center shimmer"
                      @click="openmodelmyle(false, false)"
                      style="
                        pointer-events: all;
                        cursor: pointer;
                        margin: auto;
                        display: block;
                        font-family: 'Wix Madefor Text', sans-serif;
                        font-weight: 700;
                        font-size: 1em;
                        font-weight: bold;
                      "
                    >
                      Get Tickets
                    </button>
                  </p>
                </div>
              </div>

              <!-- <video-embed
                css="embed-responsive-16by9"
                src="https://youtu.be/ONvOXdXT07U?si=faB2tivrpJNZpKKj"
              ></video-embed> -->

              <div class="container text-center mt-5" style="width: 100%">
                <div class="player-container">
                  <video-player ref="videoPlayer" :options="options3">
                  </video-player>
                </div>
              </div>

              <div class="row mt-5" id="d15">
                <div
                  class="col-md-12 col-md-12"
                  style="font-family: 'Montserrat', sans-serif"
                >
                  <p
                    class=""
                    style="
                      font-family: 'Wix Madefor Text', sans-serif;
                      font-weight: 400;
                      font-size: 1.4em;
                      color: #110f0f;
                    "
                  >
                    <span
                      style="
                        font-family: 'Wix Madefor Text', sans-serif;
                        font-weight: 400;
                        font-size: 0.9em;
                      "
                    >
                      The "AI & The Future of Entrepreneurship" fireside chat
                      will adopt a dynamic, interview-style format reminiscent
                      of the Prosperity Playbook podcast, focusing on actionable
                      strategies, mindset shifts, and real-world examples to
                      empower attendees to achieve AI-driven success. Expect a
                      fast-paced, insightful conversation that demystifies AI
                      and provides a roadmap for growth and financial
                      empowerment.

                      <br /><br />
                      AI is being leveraged to enhance the event experience from
                      start to finish. AI-powered tools were used to:
                      <br />

                      •
                      <span class="bolded">
                        Generate engaging video content
                      </span>
                      for promotion, creating dynamic visuals and compelling
                      narratives.<br />

                      •
                      <span class="bolded">
                        Personalize the registration page </span
                      >, tailoring information and recommendations to individual
                      interests.<br />

                      •
                      <span class="bolded">
                        Optimize the event website and materials </span
                      >, ensuring a seamless and informative experience for all
                      registrants.<br />
                    </span>
                  </p>
                </div>
              </div>
              <!-- <hr />
              <br />

              <div class="row text-center">
                <div
                  class="col-md-12 col-md-12"
                  style="font-family: 'Montserrat', sans-serif"
                >
                  <p
                    class="text-center"
                    style="
                      font-family: 'Wix Madefor Text', sans-serif;
                      font-size: 1.6em;
                      font-weight: 700;
                      color: #eae492;
                    "
                  >
                    <span
                      style="
                        font-family: 'Wix Madefor Display', sans-serif;
                        font-size: 1.6em;
                        font-weight: 700;
                        color: #110f0f;
                      "
                    >
                      VENDOR REGISTRATION
                    </span>
                  </p>

                  <p
                    class=""
                    style="
                      font-family: 'Wix Madefor Text', sans-serif;
                      font-size: 1.6em;
                      color: #000000;
                    "
                  >
                    <button
                      class="btn solid-btn-Entrepreneurship text-center shimmer"
                      @click="openmodelmyle(true, false)"
                      style="
                        pointer-events: all;
                        cursor: pointer;
                        margin: auto;
                        display: block;
                        font-family: 'Wix Madefor Text', sans-serif;
                        font-weight: 700;
                        font-size: 1em;
                        font-weight: bold;
                      "
                    >
                      Register
                    </button>
                  </p>
                </div>
                <br />
              </div> -->
            </div>
          </div>
        </div>
      </div>
    </div>
    <site-footer :show-subscribe="true" />
  </div>
</template>

<script>
// Component Imports
// import PoloxJazzSponsors from "../../views/commons/PoloxJazzSponsors";
import { StripeCheckout } from "@vue-stripe/vue-stripe";
import axios from "axios";
import confirmationPopup from "../../components/confirmationPopup";
import VueElementLoading from "vue-element-loading";
import NavBar from "../../views/commons/NavBar";
import SiteFooter from "../../views/index-five/SiteFooter";
import { videoPlayer } from "vue-video-player";

// import { VueFlux, FluxPreloader, FluxControls } from "vue-flux";
// import { videoPlayer } from "vue-video-player";
// import TheGlowUpSponsors from "../../views/commons/TheGlowUpSponsors";

// defining component state
export default {
  name: "newyear",
  data() {
    return {
      daylist12: {},
      daylistx: {},
      daylisty: {},
      options2: {
        height: 600,
        start: 0,
        playsinline: false,
        muted: false,
        language: "en",
        playbackRates: [0.7, 1.0, 1.5, 2.0],
        sources: [
          {
            type: "video/mp4",
            src: "https://storage.googleapis.com/wnk1yeeawadm9lfc8qu5ctszt99ghpd1rqh1p7w71bhqiaqfl0tasz1y525o/mylesite/the_glow_up_Frozen.mov",
          },
        ],
        poster:
          "https://storage.googleapis.com/wnk1yeeawadm9lfc8qu5ctszt99ghpd1rqh1p7w71bhqiaqfl0tasz1y525o/mylesite/img_SmokeSick_thumbnail.png",
      },

      options1: {
        height: 450,
        start: 0,
        playsinline: false,
        muted: false,
        language: "en",
        playbackRates: [0.7, 1.0, 1.5, 2.0],
        sources: [
          {
            type: "video/mp4",
            src: "https://storage.googleapis.com/wnk1yeeawadm9lfc8qu5ctszt99ghpd1rqh1p7w71bhqiaqfl0tasz1y525o/mylesite/mov_AITheFutureOfEntrepreneurship_V3.mp4",
          },
        ],
        poster:
          "https://storage.googleapis.com/wnk1yeeawadm9lfc8qu5ctszt99ghpd1rqh1p7w71bhqiaqfl0tasz1y525o/mylesite/header_AITheFutureOfEntrepreneurship_V3.png",
      },

      options3: {
        height: 450,
        start: 0,
        playsinline: false,
        muted: false,
        language: "en",
        playbackRates: [0.7, 1.0, 1.5, 2.0],
        sources: [
          {
            type: "video/mp4",
            src: "https://storage.googleapis.com/wnk1yeeawadm9lfc8qu5ctszt99ghpd1rqh1p7w71bhqiaqfl0tasz1y525o/mylesite/mov_AI_PPP_Video_Presentation.mp4",
          },
        ],
        poster: "",
      },

      cntholder: {},
      isDonate: false,
      isSponsor: false,
      thermoResult: 0,
      options: {
        text: {
          color: "black",
          fontSize: 14,
          textAdjustmentY: 2,
          fontFamily: "Arial",
          textEnabled: true,
        },
        thermo: {
          color: "#145143",
          backgroundColor: "#ffffff",
          frameColor: "black",
          ticks: 16,
          ticksEnabled: true,
          tickColor: "black",
          tickWidth: "1",
        },
        layout: {
          height: 600,
          width: 140,
        },
      },

      selectedCarts: [],
      ttypelist: null,
      ttypelist1: null,
      nameOfBusiness: "",
      interested: "Yes",
      address: "",
      cityStateZip: "",
      contactPerson: "",
      telephoneNumber: "",
      emailAddress: "",
      attendingGala: "Yes",
      participateInVendor: "No",
      names: {},
      showsuccess: false,
      userContactPhone: "",
      vchange: true,
      validSection: true,
      elName: "",
      eEmail: "",
      business_organization_name: "",
      emNumber: "",
      eTitle: "",
      eRefferedBy: "",
      efatherName: "",
      efEmail: "",
      ePhoneNumber: "",
      eOrgNumber: "",
      age: {},
      agecount: {},
      section2: [
        // "tk_xOSE1eC9qA32mK9",
        // "tk_rN6Ulfjw7kR6bs3",
        // "tk_Th3OQmFsgiGHdyl",
        // "tk_dOoR4tK1mdzWXz9",
        // "tk_n86GjBb59mvADgM",
        // "tk_YUjIwRpufa2Sw64",
      ],

      donations: [
        // "tk_dddVPyUpdC2vk8A",
        // "tk_HKU4ZAscQQf9Xza",
        // "tk_eAasLWDFnK9saSy",
        // "tk_lZtHUdSONEYRpK5",
      ],
      sponsors: [
        "tk_kuB8hQM81aJYuWW",
        "tk_Se47vi06H3wIeqj",
        "tk_TmTlM6ZUEA38OL8",
      ],
      pricemap: {
        tk_OyGbyK8hT0tXXsQ: "price_1RHeleD0vTZ4QB9c39SL7fyF",
        tk_qNAhbJc2iOcr18Q: "price_1RHeiVD0vTZ4QB9cOZDLRs8e",
        tk_evUvidchMmzeAuV: "price_1RF3AdD0vTZ4QB9cvoJvcESq",
        tk_kuB8hQM81aJYuWW: "price_1RGrSmD0vTZ4QB9cxykAPIPM",
        tk_Se47vi06H3wIeqj: "price_1RGrSnD0vTZ4QB9cWz26B55M",
        tk_TmTlM6ZUEA38OL8: "price_1RGrUCD0vTZ4QB9cc4snCYRs",

        // tk_3nDVdcjh0K1desL: "price_1R65u1D0vTZ4QB9cjpBl0xWb",
        // tk_kyWC1azd4Qnk5kS: "price_1R65u1D0vTZ4QB9caFItABaB",
        // tk_kOETBVAI4g7qXBG: "price_1R65u2D0vTZ4QB9ccjD7I9xt",
        // tk_AEd1IZ0yz2b7oaF: "price_1REIT0D0vTZ4QB9cqMcQDi2D",
        // tk_bqESasa6RWp3N9O: "price_1R65u2D0vTZ4QB9c3Ubeyy4C",
        // tk_gSIbZkadtNYaUpy: "price_1R65u3D0vTZ4QB9cOrlrrd5s",
        // tk_aIQ8WRpvPXYkiII: "price_1R65u3D0vTZ4QB9cVcJPQ975",

        // tk_dddVPyUpdC2vk8A: "price_1RDv9dD0vTZ4QB9cXWlU3DD2",
        // tk_HKU4ZAscQQf9Xza: "price_1RDvAWD0vTZ4QB9c1mPTxbrl",
        // tk_eAasLWDFnK9saSy: "price_1RDvAWD0vTZ4QB9cyLlPXWDl",
        // tk_lZtHUdSONEYRpK5: "price_1RDvAXD0vTZ4QB9cURD1R6XE",
      },

      daylist: {},
      daylist1: {},
      completeList: [],
      initvalue: {},

      section1: [
        "tk_OyGbyK8hT0tXXsQ",
        "tk_qNAhbJc2iOcr18Q",
        "tk_evUvidchMmzeAuV",
        "tk_kuB8hQM81aJYuWW",
        "tk_Se47vi06H3wIeqj",
        "tk_TmTlM6ZUEA38OL8",

        // "tk_682o2jRHufBiMeE",
        // "tk_3nDVdcjh0K1desL",
        // // "tk_kyWC1azd4Qnk5kS",
        // // "tk_kOETBVAI4g7qXBG",
        // "tk_AEd1IZ0yz2b7oaF",
        // "tk_bqESasa6RWp3N9O",
        // "tk_gSIbZkadtNYaUpy",
        // "tk_aIQ8WRpvPXYkiII",

        // "tk_dddVPyUpdC2vk8A",
        // "tk_HKU4ZAscQQf9Xza",
        // "tk_eAasLWDFnK9saSy",
        // "tk_lZtHUdSONEYRpK5",
      ],

      redeempromo: "",
      redeemData: null,
      reserveFormAccept: false,
      reserveFormAcceptAboutSurveyOptIn: false,
      tkList: {
        tk_OyGbyK8hT0tXXsQ: {
          messages: [],
        },

        tk_qNAhbJc2iOcr18Q: {
          messages: [],
        },

        tk_evUvidchMmzeAuV: {
          messages: [],
        },

        tk_kuB8hQM81aJYuWW: {
          messages: [],
        },

        tk_Se47vi06H3wIeqj: {
          messages: [],
        },

        tk_TmTlM6ZUEA38OL8: {
          messages: [],
        },

        // tk_682o2jRHufBiMeE: {
        //   messages: [],
        // },

        // tk_3nDVdcjh0K1desL: {
        //   messages: [],
        // },

        // tk_kyWC1azd4Qnk5kS: {
        //   messages: [],
        // },

        // tk_kOETBVAI4g7qXBG: {
        //   messages: [],
        // },

        // tk_AEd1IZ0yz2b7oaF: {
        //   messages: [],
        // },

        // tk_bqESasa6RWp3N9O: {
        //   messages: [],
        // },

        // tk_gSIbZkadtNYaUpy: {
        //   messages: [],
        // },

        // tk_aIQ8WRpvPXYkiII: {
        //   messages: [],
        // },

        // tk_dddVPyUpdC2vk8A: {
        //   messages: [],
        // },

        // tk_HKU4ZAscQQf9Xza: {
        //   messages: [],
        // },

        // tk_eAasLWDFnK9saSy: {
        //   messages: [],
        // },

        // tk_lZtHUdSONEYRpK5: {
        //   messages: [],
        // },
      },

      priceIds: {
        tk_OyGbyK8hT0tXXsQ: "price_1RHeleD0vTZ4QB9c39SL7fyF",
        tk_qNAhbJc2iOcr18Q: "price_1RHeiVD0vTZ4QB9cOZDLRs8e",
        tk_evUvidchMmzeAuV: "price_1RF3AdD0vTZ4QB9cvoJvcESq",
        tk_kuB8hQM81aJYuWW: "price_1RGrSmD0vTZ4QB9cxykAPIPM",
        tk_Se47vi06H3wIeqj: "price_1RGrSnD0vTZ4QB9cWz26B55M",
        tk_TmTlM6ZUEA38OL8: "price_1RGrUCD0vTZ4QB9cc4snCYRs",

        // tk_682o2jRHufBiMeE: "price_1RCDXRD0vTZ4QB9cIig8W2B7",
        // tk_3nDVdcjh0K1desL: "price_1R65u1D0vTZ4QB9cjpBl0xWb",
        // // tk_kyWC1azd4Qnk5kS: "price_1R65u1D0vTZ4QB9caFItABaB",
        // // tk_kOETBVAI4g7qXBG: "price_1R65u2D0vTZ4QB9ccjD7I9xt",
        // tk_AEd1IZ0yz2b7oaF: "price_1REIT0D0vTZ4QB9cqMcQDi2D",
        // tk_bqESasa6RWp3N9O: "price_1R65u2D0vTZ4QB9c3Ubeyy4C",
        // tk_gSIbZkadtNYaUpy: "price_1R65u3D0vTZ4QB9cOrlrrd5s",
        // tk_aIQ8WRpvPXYkiII: "price_1R65u3D0vTZ4QB9cVcJPQ975",

        // tk_dddVPyUpdC2vk8A: "price_1RDv9dD0vTZ4QB9cXWlU3DD2",
        // tk_HKU4ZAscQQf9Xza: "price_1RDvAWD0vTZ4QB9c1mPTxbrl",
        // tk_eAasLWDFnK9saSy: "price_1RDvAWD0vTZ4QB9cyLlPXWDl",
        // tk_lZtHUdSONEYRpK5: "price_1RDvAXD0vTZ4QB9cURD1R6XE",
      },

      countsListShow: [],
      eventTicketResult: [],
      selectedAccor: null,
      ticketForm: {
        name: "",
        email: "",
        phone: "",
        ticketCount: 0,
        ticketName: "",
        ticketId: "",
        method: "",
        accept: "",
        file: null,
      },
      loadStyle: {
        color: "#ffffff",
        "font-weight": "bold",
        "letter-spacing": "1rem",
        "font-size": "18px",
      },
      selected: 0,
      fullname: "",
      email: "",
      userSchool: "",
      tickcount: 1,
      tickcount1: 1,
      phone: "",
      isSubmitted: false,
      tickcountlist: [],
      tickcountlist1: [],

      show: false,
      checkout: {
        clientReferenceId: null,
        publishKey:
          "pk_live_51JEQYTD0vTZ4QB9cnmoJMhJQrCybltMAeG2uN3utIarQ342JyZSyyWFXgEdriazLZRFAR1Crne2E1d9PNQFVGxbw00RTp4QVjn",
      },
      TicketsResult: [],

      vfOptions: {
        autoplay: true,
      },
      vfTransitions: [
        "slide",
        "blinds2d",
        "explode",
        "fade",
        "round2",
        "swipe",
        "warp",
        "zip",
      ],
      vfImages: [
        "https://storage.googleapis.com/wnk1yeeawadm9lfc8qu5ctszt99ghpd1rqh1p7w71bhqiaqfl0tasz1y525o/mylesite/logo.jpeg",
        "https://storage.googleapis.com/wnk1yeeawadm9lfc8qu5ctszt99ghpd1rqh1p7w71bhqiaqfl0tasz1y525o/mylesite/logo.jpeg",
        "https://storage.googleapis.com/wnk1yeeawadm9lfc8qu5ctszt99ghpd1rqh1p7w71bhqiaqfl0tasz1y525o/mylesite/logo.jpeg",
      ],
      vfEventImgs: [
        "https://storage.googleapis.com/wnk1yeeawadm9lfc8qu5ctszt99ghpd1rqh1p7w71bhqiaqfl0tasz1y525o/mylesite/img_sickkick_slide_1.jpg",
        "https://storage.googleapis.com/wnk1yeeawadm9lfc8qu5ctszt99ghpd1rqh1p7w71bhqiaqfl0tasz1y525o/mylesite/img_sickkick_slide_2.jpg",
        "https://storage.googleapis.com/wnk1yeeawadm9lfc8qu5ctszt99ghpd1rqh1p7w71bhqiaqfl0tasz1y525o/mylesite/img_sickkick_slide_3.jpg",
        "https://storage.googleapis.com/wnk1yeeawadm9lfc8qu5ctszt99ghpd1rqh1p7w71bhqiaqfl0tasz1y525o/mylesite/img_sickkick_slide_4.jpg",
        "https://storage.googleapis.com/wnk1yeeawadm9lfc8qu5ctszt99ghpd1rqh1p7w71bhqiaqfl0tasz1y525o/mylesite/img_sickkick_slide_5.jpg",
      ],
    };
  },
  components: {
    confirmationPopup,
    VueElementLoading,
    StripeCheckout,
    NavBar,
    SiteFooter,
    videoPlayer,
    // TheGlowUpSponsors,
    // VueFlux,
    // FluxPreloader,
    // FluxControls,
    // videoPlayer,
  },
  methods: {
    setValues(c, t) {
      this.cntholder[this[t].ticketCode] = c;
    },
    openTermsModel: function () {
      this.$refs.termsModal.open();
    },
    fetchRouteTickets(list, isRoute, isDonation) {
      const routes = [
        "tk_OyGbyK8hT0tXXsQ",
        "tk_qNAhbJc2iOcr18Q",
        "tk_evUvidchMmzeAuV",
        "tk_kuB8hQM81aJYuWW",
        "tk_Se47vi06H3wIeqj",
        "tk_TmTlM6ZUEA38OL8",
        // "tk_682o2jRHufBiMeE",
        // "tk_3nDVdcjh0K1desL",
        // // "tk_kyWC1azd4Qnk5kS",
        // // "tk_kOETBVAI4g7qXBG",
        // "tk_AEd1IZ0yz2b7oaF",
        // "tk_bqESasa6RWp3N9O",
        // "tk_gSIbZkadtNYaUpy",
        // "tk_aIQ8WRpvPXYkiII",
      ];

      const donationn = [
        // "tk_dddVPyUpdC2vk8A",
        // "tk_HKU4ZAscQQf9Xza",
        // "tk_eAasLWDFnK9saSy",
        // "tk_lZtHUdSONEYRpK5",
      ];
      const sponsors = [
        "tk_kuB8hQM81aJYuWW",
        "tk_Se47vi06H3wIeqj",
        "tk_TmTlM6ZUEA38OL8",
      ];

      if (isRoute) {
        return list.filter((r) => routes.includes(r.ticketCode));
      }

      if (isDonation) {
        return list.filter((r) => donationn.includes(r.ticketCode));
      }

      return list.filter((r) => sponsors.includes(r.ticketCode));
    },

    fetchStatus() {
      const req = "https://myle-19701.uc.r.appspot.com/api/event_total_sales";
      const self = this;
      self.thermoResult = 0;
      axios
        .post(req, {
          eventId: "b9bee051LcSblN",
          userId: "",
        })
        .then((res) => {
          if (res && res.data && res.data.Result) {
            self.thermoResult =
              res.data.Result.totalSales > 0
                ? res.data.Result.totalSales / 1000
                : 0;
          }
        });
    },
    isNumber: function (evt) {
      evt = evt ? evt : window.event;
      var charCode = evt.which ? evt.which : evt.keyCode;
      if (
        charCode > 31 &&
        (charCode < 48 || charCode > 57) &&
        charCode !== 46
      ) {
        evt.preventDefault();
      } else {
        return true;
      }
    },

    addtocart(t) {
      const rec = { ...this[t] };
      if (t == "daylist" && this.tickcount < 1) {
        return;
      }
      if (t == "daylist1" && this.tickcount1 < 1) {
        return;
      }
      if (rec && t == "daylist") {
        for (let c = 0; c < this.tickcount; c++) {
          rec.tttcount = 1;
          rec.daylist = this[t];
          this.selectedCarts.push({ ...rec, t: t });
        }

        console.log("dsds", this.cntholder);
        this.setValues(
          (this.cntholder[rec.daylist.ticketCode] || 0) + this.tickcount,
          t
        );
      }

      if (rec && t == "daylist1") {
        for (let c = 0; c < this.tickcount1; c++) {
          rec.tttcount = 1;
          rec.daylist1 = this[t];
          this.selectedCarts.push({ ...rec, t: t });
        }

        this.setValues(
          (this.cntholder[rec.daylist1.ticketCode] || 0) + this.tickcount1,
          t
        );
      }
      this.selectedCarts = this.selectedCarts.map((r) => {
        if (this.redeemData && this.redeemData.ticketCode === r.ticketCode) {
          r.priceId = this.redeemData.discountedPriceId;
          this.priceIds[r.ticketCode] = this.redeemData.discountedPriceId;
          r.price = this.redeemData.price;
        }

        return r;
      });

      this.dayChange(t);
    },
    dayChange(t, code) {
      if (code) {
        this.TicketsResult.forEach((r) => {
          if (r.ticketCode == code) {
            this[t] = r;
          }
        });
      }
      console.log("dayChange", t, this[t]);
      if (t == "daylist") {
        this.tickcount = 1;
        this.tickcountlist = [];
      } else {
        this.tickcount1 = 1;
        this.tickcountlist1 = [];
      }

      //  this[t].price = 100;
      const w = this[t];
      for (
        let k = 0;
        k <
        (w.availableTickets > w.allowedPerRequest
          ? w.allowedPerRequest
          : w.availableTickets);
        k++
      ) {
        if (
          !this.isDonate &&
          !this.isSponsor &&
          !this.donations.includes(w.ticketCode)
        ) {
          this.tickcountlist.push(k + 1);
        } else if (this.isDonate && this.donations.includes(w.ticketCode)) {
          this.tickcountlist1.push(k + 1);
        } else if (this.isSponsor && this.sponsors.includes(w.ticketCode)) {
          this.tickcountlist1.push(k + 1);
        }
      }
      if (t === "daylist") {
        if (this.cntholder && this.cntholder[this[t].ticketCode] > 0) {
          const len = this.tickcountlist.length;
          this.tickcountlist = [];
          for (
            let k1 = 0;
            k1 < len - this.cntholder[this[t].ticketCode];
            k1++
          ) {
            this.tickcountlist.push(k1 + 1);
          }
        }

        if (this.tickcountlist.length == 0) {
          this.tickcount = 0;
        }
      } else {
        if (this.cntholder && this.cntholder[this[t].ticketCode] > 0) {
          const len = this.tickcountlist1.length;
          this.tickcountlist1 = [];
          for (
            let k1 = 0;
            k1 < len - this.cntholder[this[t].ticketCode];
            k1++
          ) {
            this.tickcountlist1.push(k1 + 1);
          }
        }

        if (this.tickcountlist1.length == 0) {
          this.tickcount1 = 0;
        }
      }

      if (t == "daylist") {
        this.ttypelist = { ...this[t] };
        if (!(this[t].ticketCode in this.initvalue)) {
          this.initvalue[this[t].ticketCode] = this.tickcountlist.length;
        }
      } else {
        this.ttypelist1 = { ...this[t] };
        if (!(this[t].ticketCode in this.initvalue)) {
          this.initvalue[this[t].ticketCode] = this.tickcountlist1.length;
        }
      }
    },

    deleteRec(rec, i) {
      console.log(i);
      this.selectedCarts = this.selectedCarts.filter((x, it) => it != i);
      this.ttypelist = this.TicketsResult[0];
    },
    closeModal() {
      this.showsuccess = false;
      this.$refs.confirmmodal.close();
    },

    openmodelmyle(isDonate, isSponsor) {
      this.isDonate = isDonate;
      this.isSponsor = isSponsor;
      this.validSection = true;
      this.nameOfBusiness = "";
      this.interested = "Yes";
      this.attendingGala = "Yes";
      this.participateInVendor = "No";
      this.address = "";
      this.cityStateZip = "";
      this.contactPerson = "";
      this.telephoneNumber = "";
      this.emailAddress = "";
      this.fullname = "";
      this.nameOfBusiness = "";
      this.email = "";
      this.userSchool = "";
      this.elName = "";
      this.eEmail = "";
      this.business_organization_name = "";
      this.emNumber = "";
      this.eTitle = "";
      this.eRefferedBy = "";
      this.efatherName = "";
      this.efEmail = "";
      this.userContactPhone = "";
      this.ePhoneNumber = "";
      this.eOrgNumber = "";
      this.age = {};
      this.reserveFormAccept = false;
      this.reserveFormAcceptAboutSurveyOptIn = false;
      this.names = {};
      this.ttypelist = this.TicketsResult[0];
      this.ttypelist = null;
      this.ttypelist1 = null;
      this.daylist = {};
      this.daylist1 = {};
      this.daylist12 = {};
      this.daylistx = {};
      this.daylisty = {};
      this.tickcount = 1;
      this.tickcount1 = 1;
      this.selectedCarts = [];
      this.tickcountlist = [];
      this.tickcountlist1 = [];
      this.initvalue = {};
      this.dayChange("daylist");
      this.dayChange("daylist1");
      this.redeemData = null;
      this.$refs.modal.open();
      this.selected = 0;
      const idx = 0;
      this.tickcountlist = [];
      for (
        let k = 0;
        k <
        (this.TicketsResult[idx].availableTickets >
        this.TicketsResult[idx].allowedPerRequest
          ? this.TicketsResult[idx].allowedPerRequest
          : this.TicketsResult[idx].availableTickets);
        k++
      ) {
        this.tickcountlist.push(k + 1);
      }
    },
    paynowcustom: function () {
      /**
       * This function here is for  pay methods
       */
      this.isSubmitted = true;
      const vm = this;
      const payloadData = {
        userName: this.fullname,
        userEmail: this.email.toLowerCase(),
        userId: "",
        eventId: this.TicketsResult[0].eventId,
        origin: "WEB",
        tickets: [],
      };

      //   const payloaddata = {
      //     priceId: this.redeemPriceId,
      //     eventId: this.TicketsResult[0].eventId,
      //     ticketId: this.selectedCarts[0].ticketCode,
      //     totalTickets: this.selectedCarts.length,
      //     userName: this.fullname,
      //     userEmail: this.email.toLowerCase(),
      //     additionalInfo: {},
      //     extraInfo: {
      //       phone: this.userContactPhone,
      //     },
      //   };

      this.selectedCarts.forEach((re) => {
        payloadData.tickets.push({
          priceId: this.priceIds[re.ticketCode],
          ticketId: re.ticketCode,
          totalTickets: re.tttcount,
          additionalInfo: {},
          extraInfo: {
            phone: this.userContactPhone,
            reactOptIn: this.reserveFormAcceptAboutSurveyOptIn,
            name_of_business: this.nameOfBusiness,
            interested: this.interested,
          },
        });
      });

      axios
        .post(
          "https://myle-19701.uc.r.appspot.com/api/" +
            ((this.TicketsResult[vm.selected].ticketType != "FREE" &&
              !this.redeemData) ||
            (this.redeemData && this.redeemData.price !== 0)
              ? "request_cart_tickets_v3"
              : "request_cart_tickets_v3"),
          (this.TicketsResult[vm.selected].ticketType != "FREE" &&
            !this.redeemData) ||
            (this.redeemData && this.redeemData.price !== 0)
            ? payloadData
            : payloadData
        )
        .then((re) => {
          if (re.data && re.data.Result && re.data.Result.sessionId) {
            vm.checkout.clientReferenceId = re.data.Result.sessionId;
            localStorage.setItem("refsId", vm.checkout.clientReferenceId);
            vm.$refs.checkoutRef.redirectToCheckout();
            setTimeout(() => {
              vm.isSubmitted = false;
            }, 60000);
            vm.reserveFormAccept = false;
            vm.reserveFormAcceptAboutSurveyOptIn = false;
          } else if (re.data && re.data.Message) {
            vm.$toast.success(re.data.Message, { timeout: 4000 });
            vm.isSubmitted = false;
            vm.$refs.modal.close();
          } else {
            vm.$toast.error("Session Id not Received", { timeout: 4000 });
          }
        })
        .catch(() => {
          vm.isSubmitted = false;
          vm.reserveFormAccept = false;
          vm.reserveFormAcceptAboutSurveyOptIn = false;
        });
    },
    redeem: function (tt) {
      const vm = this;
      vm.isSubmitted = true;
      axios({
        method: "post",
        url: "https://myle-19701.uc.r.appspot.com/api/redeem_promo_code",
        data: {
          eventId: this[tt].eventId,
          ticketId: this[tt].ticketCode,
          promoCode: this.redeempromo,
        },
      })
        .then((re) => {
          if (re.data.Status === "Success") {
            vm.$toast.success(re.data.Message, { timeout: 4000 });
            vm.redeemData = re.data.Result;
            this.selectedCarts = this.selectedCarts.map((r) => {
              if (
                this.redeemData &&
                this.redeemData.ticketCode === r.ticketCode
              ) {
                r.priceId = vm.redeemData.discountedPriceId;
                this.priceIds[r.ticketCode] = vm.redeemData.discountedPriceId;
                r.price = vm.redeemData.price;
              }

              return r;
            });
          }
          vm.isSubmitted = false;
        })
        .catch(() => {
          vm.isSubmitted = false;
          vm.$toast.error("Promo code failed", { timeout: 4000 });
          vm.redeemData = null;
        });
    },
    fetchAllTickets: function () {
      const vm = this;
      this.isSubmitted = true;
      this.eventTicketResult = [];
      this.TicketsResult = [];
      const payloadToPush = {
        eventId: "b9bee051LcSblN",
      };
      axios
        .post(
          "https://myle-19701.uc.r.appspot.com/api/fetchSponsoredEventTicketsWithSeating",
          payloadToPush
        )
        .then((ticketsResult) => {
          if (
            ticketsResult &&
            ticketsResult.data &&
            ticketsResult.data.Result
          ) {
            vm.TicketsResult = ticketsResult.data.Result;
          }

          vm.TicketsResult = vm.TicketsResult.filter(
            (rec) => vm.tkList[rec.ticketCode]
          );

          if (ticketsResult && ticketsResult.data.Result) {
            vm.priceedTicket = (ticketsResult.data.Result.filter(
              (r) => r.ticketCode === "tk_abUzszRQvcC6hQF"
            ) || [])[0];
            console.log(vm.priceedTicket);
            vm.TicketsResult = ticketsResult.data.Result.filter(
              (r) => this.pricemap[r.ticketCode]
            );
            vm.completeList = ticketsResult.data.Result.filter(
              (r) => this.pricemap[r.ticketCode]
            );
          }
          vm.TicketsResult = vm.completeList;
          vm.eventTicketResult = vm.TicketsResult;
          vm.dayChange("daylist");
          vm.dayChange("daylist1");
          vm.isSubmitted = false;
        })
        .catch(() => {
          vm.isSubmitted = false;
        });
    },
  },
  mounted() {
    const isScrolledIntoView = (el) => {
      if (!el) return false;
      var top = el.offsetTop;
      var left = el.offsetLeft;
      var width = el.offsetWidth;
      var height = el.offsetHeight;

      while (el.offsetParent) {
        el = el.offsetParent;
        top += el.offsetTop;
        left += el.offsetLeft;
      }

      return (
        top < window.pageYOffset + window.innerHeight &&
        left < window.pageXOffset + window.innerWidth &&
        top + height > window.pageYOffset &&
        left + width > window.pageXOffset
      );
    };

    window.addEventListener("scroll", function () {
      let container = document.querySelector("#d1");
      if (isScrolledIntoView(container)) {
        container.classList.add("fromside");
      }
      container = document.querySelector("#d2");
      if (isScrolledIntoView(container)) {
        container.classList.add("fromside");
      }
      container = document.querySelector("#d3");
      if (isScrolledIntoView(container)) {
        container.classList.add("fromside");
      }
      container = document.querySelector("#d4");
      if (isScrolledIntoView(container)) {
        container.classList.add("fromsideo");
      }
      container = document.querySelector("#d5");
      if (isScrolledIntoView(container)) {
        container.classList.add("fromsideo");
      }
      container = document.querySelector("#d6");
      if (isScrolledIntoView(container)) {
        container.classList.add("fromside");
      }
      container = document.querySelector("#d7");
      if (isScrolledIntoView(container)) {
        container.classList.add("fromside");
      }
      container = document.querySelector("#d8");
      if (isScrolledIntoView(container)) {
        container.classList.add("fromsideo");
      }
      container = document.querySelector("#d9");
      if (isScrolledIntoView(container)) {
        container.classList.add("fromsideo");
      }

      container = document.querySelector("#d10");
      if (isScrolledIntoView(container)) {
        container.classList.add("inView");
      }
      container = document.querySelector("#d11");
      if (isScrolledIntoView(container)) {
        container.classList.add("inView");
      }
      container = document.querySelector("#d12");
      if (isScrolledIntoView(container)) {
        container.classList.add("inView");
      }
      container = document.querySelector("#d13");
      if (isScrolledIntoView(container)) {
        container.classList.add("inView");
      }
      container = document.querySelector("#d14");
      if (isScrolledIntoView(container)) {
        container.classList.add("inView");
      }
      container = document.querySelector("#d15");
      if (isScrolledIntoView(container)) {
        container.classList.add("fromside");
      }
      container = document.querySelector("#d16");
      if (isScrolledIntoView(container)) {
        container.classList.add("fromsideo");
      }
      container = document.querySelector("#ban1");
      if (isScrolledIntoView(container)) {
        container.classList.add("inView");
      }

      container = document.querySelector("#d19");
      if (isScrolledIntoView(container)) {
        container.classList.add("fromsideo");
      }
    });
    this.fetchStatus();
    this.fetchAllTickets();
    const id = 1; // localStorage.getItem("refsId");
    if (
      id &&
      this.$route &&
      this.$route.query &&
      this.$route.query.checkout == "success"
    ) {
      this.$refs.confirmmodal.open();
      localStorage.removeItem("refsId");
    } else if (
      this.$route &&
      this.$route.query &&
      this.$route.query.checkout == "failed"
    ) {
      this.$refs.confirmmodal.open();
      localStorage.removeItem("refsId");
    }
  },
  computed: {
    invaliduphone() {
      if (this.userContactPhone.length <= 0) {
        return true;
      }
      return (
        (this.userContactPhone || "").match(/\d/g) &&
        (this.userContactPhone || "").trim().length >= 10
      );
    },
    invalidemail() {
      return /^[a-zA-Z0-9._-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,4}$/.test(this.email);
    },
  },
  metaInfo: {
    title: "MYLE - AI & The Future of Entrepreneurship",
    meta: [
      {
        name: "description",
        content: "MYLE - AI & The Future of Entrepreneurship",
      },

      {
        name: "keywords",
        content: "MYLE - AI & The Future of Entrepreneurship",
      },

      {
        name: "copyright",
        content: "MYLE",
      },

      {
        name: "url",
        content: "https://myle.com/ai-the-future-of-entrepreneurship",
      },
    ],
  },
};
</script>

<style scoped>
@keyframes slideInFromLeft {
  0% {
    transform: translateX(-100%);
  }
  100% {
    transform: translateX(0);
  }
}

.fromside {
  animation-duration: 1s; /* the duration of the animation */
  animation-timing-function: ease-out; /* how the animation will behave */
  animation-delay: 0s; /* how long to delay the animation from starting */
  animation-iteration-count: 1; /* how many times the animation will play */
  animation-name: slideInFromLeft; /* the name of the animation we defined above */
}

@keyframes slideInFromLefto {
  0% {
    transform: translateX(100%);
  }
  100% {
    transform: translateX(0);
  }
}

.fromsideo {
  animation-duration: 1s; /* the duration of the animation */
  animation-timing-function: ease-out; /* how the animation will behave */
  animation-delay: 0s; /* how long to delay the animation from starting */
  animation-iteration-count: 1; /* how many times the animation will play */
  animation-name: slideInFromLefto; /* the name of the animation we defined above */
}
#reserve {
  color: white;
}
#reserve:hover {
  color: #104233;
}
.background-overlay {
  background: #114436c4 !important;
  max-width: 100%;
  z-index: 9999 !important;
}
#banner {
  background-size: cover;
}
.innerimg {
  margin: auto;
  left: 0;
  right: 0;
  text-align: center;
  z-index: 1;
  max-width: 80%;
  height: auto;
  border: 1px double #d7c57d;
}

.bg-disable {
  background: pink;
  border: 1px solid pink;
  color: red !important;
  pointer-events: none;
}
.bolded {
  font-weight: 500;
}

.nu-modal.has-content.is-visible {
  max-width: 600px !important;
}

.shimmer {
  display: inline-block;
  mask: linear-gradient(-60deg, #000 30%, #0005, #000 70%) right/350% 100%;
  animation: shimmer 2.5s infinite;
}

@keyframes shimmer {
  100% {
    mask-position: left;
  }
}

@keyframes example {
  0% {
    opacity: 0;
  }
  10% {
    opacity: 0.1;
  }
  20% {
    opacity: 0.2;
  }
  30% {
    opacity: 0.3;
  }
  40% {
    opacity: 0.4;
  }
  50% {
    opacity: 0.5;
  }
  70% {
    opacity: 0.7;
  }
  80% {
    opacity: 0.8;
  }
  90% {
    opacity: 0.9;
  }
  100% {
    opacity: 1;
  }
}

.inView {
  animation-name: example;
  animation-duration: 2.5s;
}
</style>
